import { render, staticRenderFns } from "./garden27.vue?vue&type=template&id=75ff56d6&scoped=true&"
import script from "./garden27.vue?vue&type=script&lang=js&"
export * from "./garden27.vue?vue&type=script&lang=js&"
import style0 from "./garden27.vue?vue&type=style&index=0&id=75ff56d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ff56d6",
  null
  
)

export default component.exports